import { render } from "./GroupProductList.vue?vue&type=template&id=5b7ccb90"
import script from "./GroupProductList.vue?vue&type=script&lang=js"
export * from "./GroupProductList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__